import { ReplanPopoverContent } from '@automata/ui/src/ReplanPopover/ReplanPopoverContent';
import { secondsToDurationString } from '@automata/utils/time';

import { MaestroHistoricTaskProgress } from '../../types';
import TooltipBase from '../Tooltip/TooltipBase';

type ReplanVariant = 'extended' | 'reduced' | 'delayed';

export type Props = {
  previousDuration: MaestroHistoricTaskProgress['previousDuration'];
  currentDuration: MaestroHistoricTaskProgress['duration'];
  svgWidth: number;
  svgHeight: number;
  variant: ReplanVariant;
};

const ReplanTaskTooltip = ({
  previousDuration,
  currentDuration,
  svgHeight,
  svgWidth,
  variant,
}: Props): JSX.Element | null => {
  if (!previousDuration) return null;

  const taskDuration = currentDuration?.end - currentDuration?.start;
  const previousTaskDuration = previousDuration.end - previousDuration.start;

  const title = () => {
    switch (variant) {
      case 'extended':
        return 'Task time extension';
      case 'reduced':
        return 'Task time reduction';
      case 'delayed':
        return 'Task time delay';
    }
  };

  const content = () => {
    switch (variant) {
      case 'extended':
        return 'Task time was extended due to dynamic replanning of the run.';
      case 'reduced':
        return 'Task time was reduced due to dynamic replanning of the run.';
      case 'delayed':
        return 'Task time was delayed due to dynamic replanning of the run.';
    }
  };

  const prevDataContent = () => {
    if (variant === 'delayed') {
      return secondsToDurationString(previousDuration.start);
    }
    return secondsToDurationString(previousTaskDuration);
  };

  const currentDataContent = () => {
    if (variant === 'delayed') {
      return secondsToDurationString(currentDuration.start);
    }
    return secondsToDurationString(taskDuration);
  };

  const prevHeader = () => {
    if (variant === 'delayed') {
      return 'Original start time';
    }
    return 'Original duration';
  };

  const currentHeader = () => {
    if (variant === 'delayed') {
      return 'Updated start time';
    }
    return 'Updated duration';
  };

  return (
    <TooltipBase
      svgHeight={svgHeight}
      svgWidth={svgWidth}
      replan
      maxWidth={321}
    >
      <ReplanPopoverContent
        title={title()}
        content={content()}
        previousDataHeader={prevHeader()}
        previousDataContent={prevDataContent()}
        currentDataHeader={currentHeader()}
        currentDataContent={currentDataContent()}
        direction="row"
      />
    </TooltipBase>
  );
};

export default ReplanTaskTooltip;
